import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import templateCompiler from 'lodash-es/template';
import { computed } from 'vue';
import { useSentry } from '@/plugins/sentry';
export default /*#__PURE__*/_defineComponent({
  __name: 'VTemplateCompiler',
  props: {
    html: {
      default: ''
    },
    variables: {
      default: function _default() {
        return {
          property: null,
          address: null
        };
      }
    },
    isCompile: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var sentry = useSentry();
    var compiledHtml = computed(function () {
      if (!props.isCompile) {
        return props.html;
      }
      try {
        return templateCompiler(props.html)(_objectSpread({}, props.variables));
      } catch (error) {
        console.error('ERROR WHILE COMPILING TEMPLATE: ', error);
        sentry.captureException(error);
        return props.html;
      }
    });
    return {
      __sfc: true,
      props: props,
      sentry: sentry,
      compiledHtml: compiledHtml
    };
  }
});